import { ModuleWithProviders } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseConfigService, ConfigService } from '@base-shared/services';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
export function createTranslateLoader(http) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
var ɵ0 = (createTranslateLoader);
var BaseAppModule = /** @class */ (function () {
    function BaseAppModule() {
    }
    BaseAppModule.forRoot = function (config) {
        return {
            ngModule: BaseAppModule,
            providers: [
                BaseConfigService,
                {
                    provide: ConfigService,
                    useValue: config
                }
            ]
        };
    };
    return BaseAppModule;
}());
export { BaseAppModule };
export { ɵ0 };
